import { render } from "./GatilhosController.vue?vue&type=template&id=02b7bd7f&scoped=true"
import script from "./GatilhosController.vue?vue&type=script&lang=js"
export * from "./GatilhosController.vue?vue&type=script&lang=js"

import "./GatilhosController.vue?vue&type=style&index=0&id=02b7bd7f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b7bd7f"]])

export default __exports__